export default __webpack_public_path__ + "/img/uni-video-01.20c833f4.jpg";